import { render, staticRenderFns } from "./afterSaleWaitDealRouter.vue?vue&type=template&id=59e15139&scoped=true&"
import script from "./afterSaleWaitDealRouter.vue?vue&type=script&lang=js&"
export * from "./afterSaleWaitDealRouter.vue?vue&type=script&lang=js&"
import style0 from "./afterSaleWaitDealRouter.vue?vue&type=style&index=0&id=59e15139&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59e15139",
  null
  
)

export default component.exports